import { palette } from '../global/palette';
import { typography } from '../global/typography';
export const MuiSvgIcon = {
    MuiSvgIcon: {
        styleOverrides: {
            /* Styles applied to the root element if `color="primary"`. */
            colorPrimary: {
                color: palette.primary.main,
            },
            /* Styles applied to the root element if `color="secondary"`. */
            colorSecondary: {
                color: palette.secondary.main,
            },
            /* Styles applied to the root element if `color="action"`. */
            colorAction: {
                color: palette.grey[800],
            },
            /* Styles applied to the root element if `color="error"`. */
            colorError: {
                color: palette.error.main,
            },
            /* Styles applied to the root element if `color="disabled"`. */
            colorDisabled: {
                color: palette.text.disabled,
            },
            /* Styles applied to the root element if `fontSize="inherit"`. */
            fontSizeInherit: {
                fontSize: 'inherit',
            },
            /* Styles applied to the root element if `fontSize="small"`. */
            fontSizeSmall: {
                fontSize: typography.pxToRem(16),
            },
            /* Styles applied to the root element if `fontSize="large"`. */
            fontSizeLarge: {
                fontSize: typography.pxToRem(35),
            },
        },
    },
};
